module.exports = __webpack_public_path__ + "static/media/04.2254945b.jpg";